import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './PageHeader.css';

const PageHeader = ({ title, classNames, toolbar, withoutBackgroundGradient }) => (
  <header
    className={classnames('PageHeader', classNames, {
      'PageHeader--no-gradient': withoutBackgroundGradient,
    })}
  >
    <span className="PageHeader__title">{title}</span>
    {toolbar && <span className="PageHeader__toolbar">{toolbar}</span>}
  </header>
);

PageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  classNames: PropTypes.string,
  withoutBackgroundGradient: PropTypes.bool,
  toolbar: PropTypes.node,
};

PageHeader.defaultProps = {
  classNames: '',
  toolbar: null,
  withoutBackgroundGradient: false,
};

export default PageHeader;



// WEBPACK FOOTER //
// ../ui-components/components/PageHeader/PageHeader.jsx